module.exports = "<div (click)=\"toggleInfo\">\r\n    More information\r\n    <div [class.show]=\"showInfo\">\r\n\r\n    </div>\r\n</div>\r\n"